type PublicSetting = {
	key?: unknown;
	value?: unknown;
};

export const isRootDealerUser = (publicSettings: unknown, username?: string) => {
	if (!Array.isArray(publicSettings) || !username?.trim()) return false;

	const rootDealerUsername = (publicSettings as PublicSetting[]).find(
		(setting) => setting.key === 'rootDealerUsername',
	)?.value;

	return (
		typeof rootDealerUsername === 'string' &&
		rootDealerUsername.trim().toLowerCase() === username.trim().toLowerCase()
	);
};

export const canAccessTransactionalSmsProviders = (
	canControlSmsProvider: unknown,
	isRootUser: boolean,
) => isRootUser || canControlSmsProvider === true;

